import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a85a92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "inner" }

import { InfoCard, Button } from '@components';
import { stayUpdatedUrl } from '../../envVariables';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveBanner',
  setup(__props) {

const handleClick = () => {
  window.location.href = stayUpdatedUrl;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InfoCard), {
        class: "liveBanner",
        "icon-name": "eye",
        text: 'Need to keep an eye on this route?',
        lg: true,
        "background-color": '#DAEDED'
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            outline: true,
            label: _ctx.$t('Receive live updates'),
            onClick: handleClick
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})